angular.module("ainapp")
    .controller("viewPackingListController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {


            $scope.PageName = "Packing List Preview";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.init = function () {

                $scope.load = true;
                $scope.VoucherData = {};

                if ($stateParams.VoucherId > 0) {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.getPackingListbyId($stateParams.VoucherId).then(function (response) {
                        if (response.data) {
                            $scope.VoucherData = response.data[0];
                        }
                        $scope.load = false;
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        $scope.load = false;
                        $.LoadingOverlay("hide");
                        toastr.error("NetworkError");
                    })
                }

            }

            $scope.init();

            $scope.Edit = function () {
                $state.go("editPackingList", {
                    VoucherId: $stateParams.VoucherId
                })
            };




        }])
